import {
  DefaultRtbCampaignBasicFormModel,
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType } from 'core/rtbCampaign/RtbCampaign';

export interface OneForAllDisplayFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}
abstract class AbstractOneForAllDisplayFormModel
  extends DefaultRtbCampaignBasicFormModel
  implements OneForAllDisplayFormModel
{
  get campaignAdType(): AdType {
    return AdType.ONE_FOR_ALL_DISPLAY;
  }
}

export class EditOneForAllDisplayFormModel extends AbstractOneForAllDisplayFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }

  canEditOptimize(): boolean {
    return false;
  }
}
